import React from 'react';
import ListCourses from '../../../components/ListCourses';
import { Flex, Typo, DashboardCourseCard } from '../../../ui';
import PageSection from '../../../ui/Page/PageSection';

const SearchResults = ({ courses }) => {
  return (
    <PageSection>
      <Flex width='100%' direction='column' align='flex-start' gap='20'>
        <Typo.ContentSmallHeader $textAlign='left'>Search results</Typo.ContentSmallHeader>
        <ListCourses showProgress={true} showButtons={false} module={'dashboard'} items={courses} CardComponent={DashboardCourseCard} />
      </Flex>
    </PageSection>
  );
};

export default SearchResults;
